import sumoLogo from '../images/sumo_logo.png'
import { Button } from '../components/button'
import { useNavigate } from 'react-router-dom'
import { AuthLayout } from '../components/auth-layout'
import { Avatar } from '../components/avatar'
import { Heading } from '../components/heading'

export default function AccountSetup() {
  const navigate = useNavigate();
  const handleNavigate = (event) => {
    const buttonId = event.currentTarget.id;
    switch (buttonId) {
      case 'user':
         navigate('/user-registration');
        break;
      case 'agency':
         navigate('/agency-registration');
        break;
      default:
        console.warn('Unknown button ID:', buttonId);
    }
  };
  return (

<AuthLayout>
	<div className="grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center">

		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-2">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-1xl py-1">Let's get you started</Heading>
		<Heading className="text-center !text-1xl py-1">How many Google Merchant Centers do you manage ?</Heading>
		<div className="flex justify-center space-x-4 py-3">
			<Button color="white" type="button" id="user" className="px-4 py-2 cursor-pointer" onClick={handleNavigate}>Just the one!</Button>
			<Button type="button" id="agency" className="px-4 py-2 cursor-pointer" onClick={handleNavigate}>More than one</Button>
		</div>
	</div>
</AuthLayout>


);
}